var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    rx: 4,
    fill: "#0C8CE9",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1749 10.567L21.696 11.0459L23.2903 12.6402V13.1774H22.1553L21.258 13.8955V2H9.7419V13.9578L9.27448 13.589L9.18202 13.5161H7.70965V12.6402L9.30395 11.0459L8.82502 10.567L7.03223 12.3598V23H23.9677V12.3598L22.1749 10.567ZM10.4193 2.67742H20.5806V14.4374L15.4986 18.503L10.4193 14.4926V2.67742ZM23.2903 21.8436L19.1265 17.6799L18.6476 18.1588L22.8114 22.3226H8.18858L12.3523 18.1588L11.8734 17.6799L7.70965 21.8436V14.1935H8.94695L15.5013 19.368L22.3931 13.8548H23.2903V21.8436Z",
    fill: "#0C8CE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4841 19.9531H13.8066V20.6305H14.4841V19.9531Z",
    fill: "#0C8CE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1286 19.9531H12.4512V20.6305H13.1286V19.9531Z",
    fill: "#0C8CE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.193 19.9531H16.5156V20.6305H17.193V19.9531Z",
    fill: "#0C8CE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8386 19.9531H15.1611V20.6305H15.8386V19.9531Z",
    fill: "#0C8CE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9031 10.4667V6.40222C19.9031 5.84199 19.4472 5.38609 18.887 5.38609H17.5322V4.70867C17.5322 4.33507 17.2283 4.03125 16.8547 4.03125H14.1451C13.7715 4.03125 13.4676 4.33507 13.4676 4.70867V5.38609H12.1128C11.5526 5.38609 11.0967 5.84199 11.0967 6.40222V10.4667C11.0967 11.027 11.5526 11.4829 12.1128 11.4829H18.887C19.4472 11.4829 19.9031 11.027 19.9031 10.4667ZM14.1451 4.70867H16.8547V5.38609H14.1451V4.70867ZM11.7741 6.40222C11.7741 6.21525 11.9258 6.06351 12.1128 6.06351H18.887C19.074 6.06351 19.2257 6.21525 19.2257 6.40222V7.19819L17.3069 8.05072C16.1617 8.56014 14.8381 8.56014 13.6929 8.05072L11.7741 7.19819V6.40222ZM11.7741 10.4667V7.93962L13.4179 8.66988C14.0773 8.9632 14.7778 9.1119 15.4999 9.1119C16.222 9.1119 16.9225 8.9632 17.582 8.66988L19.2257 7.93962V10.4667C19.2257 10.6537 19.074 10.8054 18.887 10.8054H12.1128C11.9258 10.8054 11.7741 10.6537 11.7741 10.4667Z",
    fill: "#0C8CE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5485 19.9531H17.8711V20.6305H18.5485V19.9531Z",
    fill: "#0C8CE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCard);
export default __webpack_public_path__ + "static/media/job_card.234034aed8b480ad703c1c3f01607a80.svg";
export { ForwardRef as ReactComponent };